import React, { createContext, useState, useContext } from 'react'

const SettingsSidebarContext = createContext()

export function SettingsSidebarProvider({ children }) {
    const [isOpen, setIsOpen] = useState(true)

    const toggleSidebar = () => {
        setIsOpen(!isOpen)
    }

    return (
        <SettingsSidebarContext.Provider value={{ isOpen, toggleSidebar }}>
            {children}
        </SettingsSidebarContext.Provider>
    )
}

export function useSettingsSidebar() {
    return useContext(SettingsSidebarContext)
}